<div class="min-h-screen xl:flex">
  <!-- Opened from the admin panel without a login: read-only preview. -->
  <div *ngIf="adminPreview"
    class="fixed bottom-4 left-1/2 z-50 flex -translate-x-1/2 items-center gap-2 rounded-full bg-gray-900/90 px-4 py-2 text-xs font-medium text-white shadow-lg">
    <span class="h-2 w-2 rounded-full bg-amber-400"></span>
    Admin preview · read-only
  </div>
  <div
      class="flex-1 transition-all duration-300 ease-in-out"
  >
    <app-app-header/>
    <div>
      <router-outlet></router-outlet>
    </div>
    <app-app-footer *ngIf="showFooter"></app-app-footer>
  </div>
</div>
 